import React from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import Config from '../config'
import {Page, LabelBar, Preload, PageBottomText, WKError} from '../components'
import {WalletNewHeader, WalletNewInfo} from '../components/wallet'
import '../css/page/WalletNewPage.css'
import errorImg from '../images/no-source.png'


class WalletPageNew extends React.Component {

    constructor() {
        super();
        this.state = {
            init: false,
            moneyInfo: null
        }
    }

    componentDidMount() {
        document.title = '我的钱包';

        axios.get('/api/wallet/init_new')
            .then(res => {
                if (res.data.code === 0) {
                    this.setState({
                        init: true,
                        moneyInfo: res.data.data.wallet_info
                    })
                }
            }).catch((error) => {
            if (error.response) {
                this.props.dispatch({
                    type: 'ERROR_SHOW',
                    payload: {
                        tips: '网络连接出错。',
                        img: errorImg,
                        href: '/?st=wallet_404',
                        btn: '去首页看看'
                    }
                });
            }
            console.log(error)
        });
    }

    handleLabelClick() {
        if (/lycheer/.test(navigator.userAgent.toLocaleLowerCase())){
            window.location.href = 'lizhiweike://liveroom?liveroom_id=23715304'
        }else {
            window.location.href = Config.MAIN_URL + '/liveroom/23715304'
        }
    }

    render() {
        const {init, moneyInfo} = this.state;
        const {error} = this.props;

        if (error.showError) {
            return (
                <div style={{background: '#fff', width: '100%', height: '100vh'}}>
                    <WKError />
                </div>
            )
        }

        if (!init) {
            return <Preload/>
        }

        return (
            <Page>
                <div className="wallet-new-page">

                    <WalletNewHeader moneyInfo={moneyInfo}/>

                    <WalletNewInfo moneyInfo={moneyInfo}/>

                    <LabelBar onCellClick={this.handleLabelClick.bind(this)}>
                        <p className="label-text">想提高收益？金牌老师手把手教你赚钱</p>
                    </LabelBar>

                    <div style={{position: 'absolute', bottom: '0', width: '100%'}}>
                        <PageBottomText isLink={false}/>
                    </div>

                </div>
            </Page>
        )
    }
}

export default connect(state => ({
    error: state.error,
}))(WalletPageNew)



// WEBPACK FOOTER //
// ./src/pages/WalletPageNew.js